import { Person, Vorgang } from '../../types';

export function holeGeschaedigten(vorgang: Vorgang | null | undefined): Person | null | undefined {
  return vorgang?.fahrzeughalterIstAuftraggeber ? vorgang?.auftraggeber : vorgang?.fahrzeughalter;
}
